import packageJson from '../package.json';

export const minApiVersion: string = '4.1.2312.0';
export const appVersion: string = packageJson.version;

export const appBarHeight: number = 64;
export const navBarHeight: number = 56;